// removed by extract-text-webpack-plugin
module.exports = {"dropdown":"Dropdown__dropdown__1G0fO","select":"Dropdown__select__3KE53"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Dropdown/Dropdown.scss
// module id = 1908
// module chunks = 0